module.exports = __webpack_public_path__ + "img/logo.51c8787f.svg";